var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeerlessSteel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.62 131.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#New_Gradient_Swatch_3-10);}.cls-3{fill:url(#_1248-4);}.cls-4{fill:url(#_1248-3);}.cls-5{fill:url(#_1248-2);}.cls-6{fill:url(#_1321-3);}.cls-7{fill:url(#_1321-4);}.cls-8{fill:url(#_1321-2);}.cls-9{fill:url(#_1321-6);}.cls-10{fill:url(#_1321-5);}.cls-11{fill:url(#_236-12);}.cls-12{fill:url(#_236-11);}.cls-13{fill:url(#_236-16);}.cls-14{fill:url(#_236-10);}.cls-15{fill:url(#_236-15);}.cls-16{fill:url(#_236-14);}.cls-17{fill:url(#_236-13);}.cls-18{fill:url(#linear-gradient);}.cls-19{fill:url(#_127-2);}.cls-19,.cls-20,.cls-21{mix-blend-mode:color-dodge;}.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32{opacity:.5;}.cls-20{fill:url(#_127-3);}.cls-33{fill:url(#_236);}.cls-21{fill:url(#_127);}.cls-34{fill:url(#_1321);}.cls-35{fill:url(#_1248);}.cls-36{fill:url(#New_Gradient_Swatch_2);}.cls-37{fill:url(#New_Gradient_Swatch_3);}.cls-22{fill:url(#New_Gradient_Swatch_1);}.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32{mix-blend-mode:multiply;}.cls-38{fill:url(#linear-gradient-3);}.cls-39{fill:url(#linear-gradient-2);}.cls-23{fill:url(#New_Gradient_Swatch_1-10);}.cls-24{fill:url(#New_Gradient_Swatch_1-11);}.cls-25{fill:url(#New_Gradient_Swatch_1-6);}.cls-26{fill:url(#New_Gradient_Swatch_1-9);}.cls-27{fill:url(#New_Gradient_Swatch_1-7);}.cls-28{fill:url(#New_Gradient_Swatch_1-4);}.cls-29{fill:url(#New_Gradient_Swatch_1-3);}.cls-30{fill:url(#New_Gradient_Swatch_1-8);}.cls-31{fill:url(#New_Gradient_Swatch_1-5);}.cls-32{fill:url(#New_Gradient_Swatch_1-2);}.cls-40{fill:url(#radial-gradient);}.cls-41{isolation:isolate;}.cls-42{fill:url(#New_Gradient_Swatch_2-9);}.cls-43{fill:url(#New_Gradient_Swatch_2-6);}.cls-44{fill:url(#New_Gradient_Swatch_2-5);}.cls-45{fill:url(#New_Gradient_Swatch_2-2);}.cls-46{fill:url(#New_Gradient_Swatch_2-4);}.cls-47{fill:url(#New_Gradient_Swatch_2-3);}.cls-48{fill:url(#New_Gradient_Swatch_2-8);}.cls-49{fill:url(#New_Gradient_Swatch_2-7);}.cls-50{fill:url(#New_Gradient_Swatch_3-5);}.cls-51{fill:url(#New_Gradient_Swatch_3-2);}.cls-52{fill:url(#New_Gradient_Swatch_3-6);}.cls-53{fill:url(#New_Gradient_Swatch_3-7);}.cls-54{fill:url(#New_Gradient_Swatch_3-8);}.cls-55{fill:url(#New_Gradient_Swatch_3-3);}.cls-56{fill:url(#New_Gradient_Swatch_3-9);}.cls-57{fill:url(#New_Gradient_Swatch_3-4);}.cls-58{fill:url(#_236-9);}.cls-59{fill:url(#_236-7);}.cls-60{fill:url(#_236-6);}.cls-61{fill:url(#_236-5);}.cls-62{fill:url(#_236-4);}.cls-63{fill:url(#_236-8);}.cls-64{fill:url(#_236-3);}.cls-65{fill:url(#_236-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 70.37,
    cy: 68.65,
    fx: -1.02,
    fy: 6.82,
    r: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a198a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e2c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2c1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236",
    x1: 74.31,
    y1: 0,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 74.31,
    y1: 83.91,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5ba4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-2",
    x1: 74.31,
    y1: 129.92,
    x2: 74.31,
    y2: 1.93,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127",
    x1: 74.31,
    y1: -3960.5,
    x2: 74.31,
    y2: -3912.56,
    gradientTransform: "translate(0 -3912.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acbcdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 23.79,
    y1: 64.8,
    x2: 23.79,
    y2: 86.3,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321",
    x1: -7126.52,
    y1: 139.14,
    x2: -7126.52,
    y2: 119.15,
    gradientTransform: "translate(-3227.5 6367.84) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85769c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e0ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-3",
    x1: -7124.06,
    y1: 117.31,
    x2: -7124.06,
    y2: 135.04,
    gradientTransform: "translate(-3227.5 6367.84) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-4",
    x1: -7140.28,
    y1: 121.83,
    x2: -7140.28,
    y2: 128.18,
    gradientTransform: "translate(-3227.5 6367.84) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-2",
    x1: -7145.68,
    y1: 130.36,
    x2: -7145.68,
    y2: 125.1,
    gradientTransform: "translate(-3227.5 6367.84) rotate(118.16)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248",
    x1: -7141.38,
    y1: 110.44,
    x2: -7141.38,
    y2: 116.98,
    gradientTransform: "translate(-3227.5 6367.84) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: -7110.83,
    y1: 125.11,
    x2: -7110.83,
    y2: 123.57,
    gradientTransform: "translate(-3227.5 6367.84) rotate(118.16)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-5",
    x1: 4.83,
    y1: 57.22,
    x2: 0.44,
    y2: 65.9,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-2",
    x1: -11517.85,
    y1: 2489.45,
    x2: -11517.85,
    y2: 2469.46,
    gradientTransform: "translate(-3227.5 -11216.94) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-6",
    x1: -11515.4,
    y1: 2467.62,
    x2: -11515.4,
    y2: 2485.35,
    gradientTransform: "translate(-3227.5 -11216.94) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-7",
    x1: -11531.61,
    y1: 2472,
    x2: -11531.61,
    y2: 2478.53,
    gradientTransform: "translate(-3227.5 -11216.94) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-8",
    x1: -11537.02,
    y1: 2480.67,
    x2: -11537.02,
    y2: 2475.42,
    gradientTransform: "translate(-3227.5 -11216.94) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-2",
    x1: -11532.32,
    y1: 2461.22,
    x2: -11532.32,
    y2: 2467.63,
    gradientTransform: "translate(-3227.5 -11216.94) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: -11502.17,
    y1: 2475.42,
    x2: -11502.17,
    y2: 2473.88,
    gradientTransform: "translate(-3227.5 -11216.94) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-9",
    x1: -0.18,
    y1: 81.87,
    x2: 5.98,
    y2: 77.39,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-3",
    x1: 19.46,
    y1: 71.54,
    x2: 3.04,
    y2: 59.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 10.82,
    y1: 58.22,
    x2: 10.82,
    y2: 72.25,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 10.82,
    y1: 21.03,
    x2: 10.82,
    y2: 35.06,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: -6230.75,
    y1: 64.8,
    x2: -6230.75,
    y2: 86.3,
    gradientTransform: "translate(-6105.92) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-4",
    x1: -4175.25,
    y1: 5653.3,
    x2: -4175.25,
    y2: 5633.31,
    gradientTransform: "translate(-2878.42 6367.84) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-10",
    x1: -4172.79,
    y1: 5631.47,
    x2: -4172.79,
    y2: 5649.2,
    gradientTransform: "translate(-2878.42 6367.84) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-11",
    x1: -4189.01,
    y1: 5636,
    x2: -4189.01,
    y2: 5642.34,
    gradientTransform: "translate(-2878.42 6367.84) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-3",
    x1: -4194.42,
    y1: 5644.52,
    x2: -4194.42,
    y2: 5639.27,
    gradientTransform: "translate(-2878.42 6367.84) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-3",
    x1: 95.21,
    y1: 18.66,
    x2: 118.73,
    y2: 12.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: -4159.56,
    y1: 5639.27,
    x2: -4159.56,
    y2: 5637.73,
    gradientTransform: "translate(-2878.42 6367.84) rotate(61.84) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-12",
    x1: -6249.71,
    y1: 57.22,
    x2: -6254.1,
    y2: 65.9,
    gradientTransform: "translate(-6105.92) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-5",
    x1: -8566.58,
    y1: 8003.61,
    x2: -8566.58,
    y2: 7983.62,
    gradientTransform: "translate(-2878.42 -11216.94) rotate(-61.84)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-13",
    x1: -8564.13,
    y1: 7981.79,
    x2: -8564.13,
    y2: 7999.51,
    gradientTransform: "translate(-2878.42 -11216.94) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-14",
    x1: -8580.35,
    y1: 7986.16,
    x2: -8580.35,
    y2: 7992.69,
    gradientTransform: "translate(-2878.42 -11216.94) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-15",
    x1: -8585.75,
    y1: 7994.84,
    x2: -8585.75,
    y2: 7989.58,
    gradientTransform: "translate(-2878.42 -11216.94) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-4",
    x1: -8581.05,
    y1: 7975.38,
    x2: -8581.05,
    y2: 7981.79,
    gradientTransform: "translate(-2878.42 -11216.94) rotate(-61.84)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-9",
    x1: -8550.9,
    y1: 7989.58,
    x2: -8550.9,
    y2: 7988.05,
    gradientTransform: "translate(-2878.42 -11216.94) rotate(-61.84)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-16",
    x1: -6254.72,
    y1: 81.87,
    x2: -6248.56,
    y2: 77.39,
    gradientTransform: "translate(-6105.92) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-6",
    x1: -6235.08,
    y1: 71.54,
    x2: -6251.5,
    y2: 59.97,
    gradientTransform: "translate(-6105.92) rotate(-180) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-10",
    x1: -6243.72,
    y1: 58.22,
    x2: -6243.72,
    y2: 72.25,
    gradientTransform: "translate(-6105.92) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-11",
    x1: -6243.72,
    y1: 21.03,
    x2: -6243.72,
    y2: 35.06,
    gradientTransform: "translate(-6105.92) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 70.77,
    y1: 27.22,
    x2: 77.67,
    y2: 27.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7c7c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9e9e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9e9e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 66.1,
    y1: 81.47,
    x2: 82.27,
    y2: 81.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#717170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#878786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a0a09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9e9e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 58.39,
    y1: 42.54,
    x2: 89.91,
    y2: 42.54,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 70.77,
    y1: 37.2,
    x2: 77.67,
    y2: 37.2,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 58.39,
    y1: 37.2,
    x2: 89.91,
    y2: 37.2,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 66.1,
    y1: 38.79,
    x2: 82.27,
    y2: 38.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 58.39,
    y1: 38.79,
    x2: 89.91,
    y2: 38.79,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 66.1,
    y1: 41.81,
    x2: 82.27,
    y2: 41.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-6",
    x1: 58.39,
    y1: 41.81,
    x2: 89.91,
    y2: 41.81,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-7",
    x1: 69.62,
    y1: 13.95,
    x2: 78.81,
    y2: 13.95,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-8",
    x1: 70.77,
    y1: 18.32,
    x2: 77.67,
    y2: 18.32,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-9",
    x1: 69.62,
    y1: 18.32,
    x2: 78.81,
    y2: 18.32,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: -138.37,
    y1: 76.7,
    x2: -138.37,
    y2: 49.27,
    gradientTransform: "translate(191.79 25.44) rotate(11.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9f9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#939392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9e9e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#747373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#919090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a1a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: -141.17,
    y1: 64.31,
    x2: -141.17,
    y2: 52.63,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: -139.41,
    y1: 69.75,
    x2: -139.41,
    y2: 58.79,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: -137.44,
    y1: 75.43,
    x2: -137.44,
    y2: 65.03,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: -134.8,
    y1: 81.69,
    x2: -134.8,
    y2: 70.93,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: -1024.05,
    y1: 105.46,
    x2: -1024.04,
    y2: 78.03,
    gradientTransform: "translate(-910.9 219.23) rotate(165.89) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: -1026.84,
    y1: 93.06,
    x2: -1026.84,
    y2: 81.39,
    gradientTransform: "translate(-910.9 219.23) rotate(165.89) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: -1025.09,
    y1: 98.5,
    x2: -1025.09,
    y2: 87.54,
    gradientTransform: "translate(-910.9 219.23) rotate(165.89) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: -1023.11,
    y1: 104.19,
    x2: -1023.11,
    y2: 93.78,
    gradientTransform: "translate(-910.9 219.23) rotate(165.89) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: -1020.47,
    y1: 110.45,
    x2: -1020.47,
    y2: 99.68,
    gradientTransform: "translate(-910.9 219.23) rotate(165.89) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 74.32,
    cy: 66.36,
    r: 63.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m74.32,0C37.9,0,8.39,29.52,8.39,65.93s29.52,65.93,65.93,65.93,65.93-29.52,65.93-65.93S110.73,0,74.32,0Zm0,128.16c-16.62,0-32.25-6.47-44-18.23-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01c-11.75,11.75-27.38,18.23-44,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m74.32,130.05c-29.77,0-54.97-19.4-63.44-46.14,7.83,27.67,33.27,47.94,63.44,47.94s55.61-20.27,63.44-47.94c-8.48,26.74-33.67,46.14-63.44,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m119.57,20.67C107.48,8.58,91.41,1.93,74.32,1.93s-33.16,6.66-45.25,18.75c-12.09,12.09-18.74,28.16-18.74,45.25s6.66,33.16,18.74,45.25c12.09,12.09,28.16,18.74,45.25,18.74s33.17-6.66,45.25-18.74c12.09-12.09,18.74-28.16,18.74-45.25s-6.66-33.17-18.74-45.25Zm-1.25,89.26c-11.75,11.75-27.38,18.23-44,18.23s-32.25-6.47-44-18.23c-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m137.76,47.94C129.93,20.27,104.49,0,74.32,0S18.7,20.27,10.87,47.94C19.35,21.2,44.55,1.99,74.32,1.99s54.97,19.21,63.44,45.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.11,98.93l1.72,5.03s.43,1.37-.28,2.8l3.93,4.53-.52-6.18-4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.96,18.03c-2.91,9.79-7.21,17.51-7.21,17.51-.98,2.17-2.33,5.08-2.33,5.08-.57,1.24-1.56,3.84-1.56,3.84,2.82-3.12,4.66-5.85,6.82-8.67,4.17-5.45,7.01-15.06,8.4-20.66.65-2.63.99-4.37.99-4.37,2.42-1.17,3.7-1.9,3.85-1.98.22-.11.45-.21.67-.31-.99-1.3-2.2-2.27-2.2-2.27-3.74-.56-5.28,1.48-5.28,1.48-.23,1.88-.54,3.7-.91,5.44-.37,1.72-.79,3.36-1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m17.43,40.62s2.11-4.66,2.25-4.9c0,0,4.38-7.9,7.29-17.69.46-1.56.89-3.2,1.26-4.91,0,0,.75,13.06-10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m31.39,15.89s-.45.46-1.8,4.68c0,0,.46-5.89,1.99-10.6,0,0,1.6-2.99,2.85-3.75.19.16,1.72,1.19,3.97,4.41-.22.1-.91.64-1.13.75-.15.09-2.43,1.73-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m29.13,7.68s1.33-1.77,4.52-1.57c-1.36,1.86-3.95,2.3-4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.39,15.89l.97-2.77c1.29-1.73,2.77-2.63,2.77-2.63,0,0,1.31.19,2.57.62l-.42.28c-3.05,2.01-5.88,4.51-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.15,41.78s.83-2.07,1.43-3.99l.85-3.5c-.12.15-.52,1.06-.67,1.24-1.61,3.22-2.54,5.26-3.89,8.92,0,0,1.64-1.96,2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m10.32,50.03s-4.56,4.81-7.29,15.9H0s.72-12.21,12.37-22.62l-2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m26.96,113.82c-2.91-9.79-7.21-17.51-7.21-17.51-.98-2.17-2.33-5.08-2.33-5.08-.57-1.24-1.56-3.84-1.56-3.84,2.82,3.12,4.66,5.85,6.82,8.67,4.17,5.45,7.01,15.06,8.4,20.66.65,2.63.99,4.37.99,4.37,2.42,1.17,3.7,1.9,3.85,1.98.22.11.45.21.67.31-.99,1.3-2.2,2.27-2.2,2.27-3.74.56-5.28-1.48-5.28-1.48-.23-1.88-.54-3.7-.91-5.44-.37-1.72-.79-3.36-1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m17.43,91.24s2.11,4.66,2.25,4.9c0,0,4.38,7.9,7.29,17.69.46,1.56.89,3.2,1.26,4.91,0,0,.75-13.06-10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m31.05,115.61s-.11-.11-1.46-4.33c0,0,.46,5.89,1.99,10.6,0,0,1.6,2.99,2.85,3.75.19-.16,3.4-3.02,4.3-4.2-.22-.1-1.69-1.17-1.91-1.28-.15-.09-2.9-1.86-5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m29.13,124.17s1.33,1.77,4.52,1.57c-1.36-1.86-3.95-2.3-4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.05,115.61l.82,2.29c.61,2.08,2.11,3.67,2.11,3.67,0,0,1.06.22,2.01-.28l1.2-.89c-.61-.33-4.12-3.04-6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m18.15,90.07s.83,2.07,1.43,3.99l.85,3.5c-.12-.15-.52-1.06-.67-1.24-1.61-3.22-2.54-5.26-3.89-8.92,0,0,1.64,1.96,2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m10.32,81.82s-4.56-4.81-7.29-15.9H0s.72,12.21,12.37,22.62l-2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m3.03,65.93c2.59-10.81,7.29-15.9,7.29-15.9l1.17-3.85C2.86,54.36,1.46,65.93,1.46,65.93c0,0,1.4,11.57,10.03,19.74l-1.17-3.85s-4.7-5.09-7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m9.27,80.49s.36,2.19.3,3.18l.74,2.91,2.05,1.97-.88-2.88-1.17-3.85-1.05-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "12.37 43.3 11.49 46.18 10.32 50.03 9.27 51.36 9.27 48.53 11.49 44.11 12.37 43.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m127.52,98.93l-1.72,5.03s-.43,1.37.28,2.8l-3.93,4.53.52-6.18,4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m121.66,18.03c2.91,9.79,7.21,17.51,7.21,17.51.98,2.17,2.33,5.08,2.33,5.08.57,1.24,1.56,3.84,1.56,3.84-2.82-3.12-4.66-5.85-6.82-8.67-4.17-5.45-7.01-15.06-8.4-20.66-.65-2.63-.99-4.37-.99-4.37-2.42-1.17-3.7-1.9-3.85-1.98-.22-.11-.45-.21-.67-.31.99-1.3,2.2-2.27,2.2-2.27,3.74-.56,5.28,1.48,5.28,1.48.23,1.88.54,3.7.91,5.44.37,1.72.79,3.36,1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m131.2,40.62s-2.11-4.66-2.25-4.9c0,0-4.38-7.9-7.29-17.69-.46-1.56-.89-3.2-1.26-4.91,0,0-.75,13.06,10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m117.24,15.89s.45.46,1.8,4.68c0,0-.46-5.89-1.99-10.6,0,0-1.6-2.99-2.85-3.75-.19.16-1.72,1.19-3.97,4.41.22.1.91.64,1.13.75.15.09,2.43,1.73,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m119.5,7.68s-1.33-1.77-4.52-1.57c1.36,1.86,3.95,2.3,4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.24,15.89l-.97-2.77c-1.29-1.73-2.77-2.63-2.77-2.63,0,0-1.31.19-2.57.62l.42.28c3.05,2.01,5.88,4.51,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m130.48,41.78s-.83-2.07-1.43-3.99l-.85-3.5c.12.15.52,1.06.67,1.24,1.61,3.22,2.54,5.26,3.89,8.92,0,0-1.64-1.96-2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m138.31,50.03s4.56,4.81,7.29,15.9h3.03s-.72-12.21-12.37-22.62l2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.66,113.82c2.91-9.79,7.21-17.51,7.21-17.51.98-2.17,2.33-5.08,2.33-5.08.57-1.24,1.56-3.84,1.56-3.84-2.82,3.12-4.66,5.85-6.82,8.67-4.17,5.45-7.01,15.06-8.4,20.66-.65,2.63-.99,4.37-.99,4.37-2.42,1.17-3.7,1.9-3.85,1.98-.22.11-.45.21-.67.31.99,1.3,2.2,2.27,2.2,2.27,3.74.56,5.28-1.48,5.28-1.48.23-1.88.54-3.7.91-5.44.37-1.72.79-3.36,1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m131.2,91.24s-2.11,4.66-2.25,4.9c0,0-4.38,7.9-7.29,17.69-.46,1.56-.89,3.2-1.26,4.91,0,0-.75-13.06,10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.58,115.61s.11-.11,1.46-4.33c0,0-.46,5.89-1.99,10.6,0,0-1.6,2.99-2.85,3.75-.19-.16-3.4-3.02-4.3-4.2.22-.1,1.69-1.17,1.91-1.28.15-.09,2.9-1.86,5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m119.5,124.17s-1.33,1.77-4.52,1.57c1.36-1.86,3.95-2.3,4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m117.58,115.61l-.82,2.29c-.61,2.08-2.11,3.67-2.11,3.67,0,0-1.06.22-2.01-.28l-1.2-.89c.61-.33,4.12-3.04,6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m130.48,90.07s-.83,2.07-1.43,3.99l-.85,3.5c.12-.15.52-1.06.67-1.24,1.61-3.22,2.54-5.26,3.89-8.92,0,0-1.64,1.96-2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m138.31,81.82s4.56-4.81,7.29-15.9h3.03s-.72,12.21-12.37,22.62l2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m145.6,65.93c-2.59-10.81-7.29-15.9-7.29-15.9l-1.17-3.85c8.63,8.18,10.03,19.74,10.03,19.74,0,0-1.4,11.57-10.03,19.74l1.17-3.85s4.7-5.09,7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m139.35,80.49s-.36,2.19-.3,3.18l-.74,2.91-2.05,1.97.88-2.88,1.17-3.85,1.04-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "136.25 43.3 137.13 46.18 138.31 50.03 139.35 51.36 139.35 48.53 137.13 44.11 136.25 43.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.43,55.93c-.03.06-.06.12-.08.18.07.13.14.27.21.41.25.51.49,1.09.72,1.73.64,1.79.95,3.69.95,5.6v13.23c0,1.43-.28,2.85-.84,4.17-.06.14-.12.27-.18.4.02.03.03.07.05.1.64,1.25.97,2.64.97,4.04l.31,19.39c0,4.78.19,5.52.65,7.23.46-1.71.63-2.39.63-7.27s.31-17.95.31-19.37.33-2.82.99-4.08c0,0,0-.02.01-.02,0,0,0-.02-.01-.03-.66-1.4-.99-2.95-.99-4.5v-13.32c0-2.31.45-4.6,1.39-6.7.08-.17.16-.34.24-.51.08-.17.17-.33.25-.49-.03-.06-.06-.12-.09-.19-1.08-2.36-4.41-2.35-5.48.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m77.61,36.58c-.05-.26-.12-.51-.24-.75-.27-.51-.42-1.1-.42-1.71,0-.48.09-.98.26-1.43.2-.55.21-1.16,0-1.72-.15-.41-.27-.93-.27-1.46,0-.48.09-.98.26-1.43.2-.55.21-1.16,0-1.71-.15-.41-.27-.93-.27-1.46,0-.48.09-.98.26-1.43.2-.55.21-1.16,0-1.71-.15-.41-.27-.93-.27-1.46,0-.62.15-1.2.42-1.71.19-.37.29-.77.29-1.18l-2.24,1.63c-.72.52-1.69.52-2.41,0l-2.24-1.63c0,.41.1.82.29,1.18.27.51.42,1.1.42,1.71,0,.53-.12,1.05-.27,1.46-.2.56-.19,1.16,0,1.71.17.45.26.95.26,1.43,0,.53-.12,1.05-.27,1.46-.2.56-.19,1.16,0,1.71.17.45.26.95.26,1.43,0,.53-.12,1.04-.27,1.46-.2.56-.19,1.16,0,1.72.17.45.26.95.26,1.43,0,.62-.15,1.2-.42,1.71-.12.24-.2.5-.24.76.96.11,2.06.26,3.33.45,1.33-.2,2.47-.35,3.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m74.23,44.28l-.08.13-.08-.13c-.97-1.6-2.38-2.83-4.02-3.59-.06,5.2-.82,11.91-3.9,15.91l-.05.07c2.96-.21,6.49,18.2,1.22,25.01l-.03.04.04.05c2.3,2.95,2.76,6.37,3.14,9.92.81,7.49-.31,18.7,3.75,30.55,4.03-11.78,2.79-22.97,3.61-30.45.39-3.57.85-7.02,3.18-9.97l.07-.09-.07-.09c-5.35-6.87-1.72-25.17,1.26-24.97l-.08-.11c-3.08-3.99-3.86-10.67-3.93-15.87-1.64.76-3.05,1.99-4.02,3.59Zm-.17,1.63c.41,0,.74.33.74.74s-.33.74-.74.74-.74-.33-.74-.74.33-.74.74-.74Zm.09,3.08c.64,0,1.15.52,1.15,1.15s-.52,1.15-1.15,1.15-1.16-.52-1.16-1.15.52-1.15,1.16-1.15Zm2.76,6.93c.03.06.06.13.09.19-.08.16-.17.32-.25.49-.08.16-.16.33-.24.51-.93,2.11-1.39,4.4-1.39,6.7v13.32c0,1.55.32,3.1.99,4.5,0,0,0,.02.01.03,0,0,0,.02-.01.02-.66,1.26-.99,2.66-.99,4.08s-.31,14.49-.31,19.37-.17,5.56-.63,7.27c-.46-1.71-.65-2.45-.65-7.23l-.31-19.39c0-1.4-.32-2.79-.97-4.04-.02-.03-.03-.07-.05-.1.06-.13.12-.27.18-.4.56-1.32.84-2.74.84-4.17v-13.23c0-1.91-.31-3.8-.95-5.6-.23-.64-.47-1.22-.72-1.73-.07-.14-.14-.28-.21-.41.03-.06.06-.12.08-.18,1.08-2.37,4.4-2.37,5.48-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m89.48,36.53c-6.27,1.16-3.24-.93-11.87.05.03.15.06.31.06.46v.79h-6.9v-.79c0-.15.03-.3.05-.45-8.79-1.01-5.69,1.11-12-.06-1.58,6.62,1.58,9.66,3.78,12.23-1.46-5.97-.98-8.48,2.75-8.88,1.64-.18,3.26.13,4.7.8,0-.24,0-.48,0-.72,0-1.15,1.07-.11,1.07-.65v-.12c-1.07-.54-2.23-.91-3.43-1.07,1.41.06,3.23.26,5.47.59h1.98c2.24-.33,4.06-.52,5.47-.59-1.2.16-2.36.53-3.44,1.07v.11c0,.53,1.07-.54,1.07.57,0,.26,0,.53,0,.8,1.44-.67,3.06-.98,4.7-.8,3.73.4,4.21,2.91,2.75,8.88,2.2-2.57,5.35-5.61,3.78-12.23Zm-28.96,7.06c-.92-2.06-.51-3.87-.37-5.01.62.08,1.16.11,1.65.11.41,0,.77-.03,1.08-.07-3.21,1.38-2.45,4.03-2.36,4.97Zm24.89-4.97c.32.04.67.07,1.08.07.48,0,1.03-.04,1.65-.11.14,1.14.55,2.95-.37,5.01.09-.93.85-3.58-2.36-4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m70.77,37.83h6.9v-.79c0-.16-.03-.31-.06-.46-.99.11-2.13.26-3.46.46-1.27-.19-2.37-.34-3.33-.45-.03.15-.05.3-.05.45v.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m70.77,37.83h6.9v-.79c0-.16-.03-.31-.06-.46-.99.11-2.13.26-3.46.46-1.27-.19-2.37-.34-3.33-.45-.03.15-.05.3-.05.45v.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m74.15,38.86l.27-.04c.25-.04.48-.07.72-.1h-1.98c.24.04.47.06.72.1l.27.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m74.15,38.86l.27-.04c.25-.04.48-.07.72-.1h-1.98c.24.04.47.06.72.1l.27.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m77.18,39.32v-.11c-1.12.57-2.15,1.32-3.03,2.24-.88-.92-1.91-1.68-3.03-2.24v.12c0,.54-1.07-.5-1.07.65,0,.23,0,.48,0,.72,1.64.76,3.05,1.99,4.02,3.59l.08.13.08-.13c.97-1.6,2.39-2.83,4.02-3.59,0-.27,0-.54,0-.8,0-1.12-1.07-.05-1.07-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m77.18,39.32v-.11c-1.12.57-2.15,1.32-3.03,2.24-.88-.92-1.91-1.68-3.03-2.24v.12c0,.54-1.07-.5-1.07.65,0,.23,0,.48,0,.72,1.64.76,3.05,1.99,4.02,3.59l.08.13.08-.13c.97-1.6,2.39-2.83,4.02-3.59,0-.27,0-.54,0-.8,0-1.12-1.07-.05-1.07-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m70.77,17.22h6.9v.15s0,.02,0,.03l.3-.22c.72-.52,1.02-1.45.74-2.29l-.97-2.99c-.27-.84-1.06-1.41-1.95-1.41h-3.14c-.89,0-1.67.57-1.95,1.41l-.97,2.99c-.27.84.03,1.77.74,2.29l.3.22s0-.02,0-.03v-.15Zm1.25-2.37l.51-1.56c.12-.38.48-.64.88-.64h1.64c.4,0,.75.26.88.64l.51,1.56c.12.38-.01.79-.33,1.03l-1.33.97c-.32.23-.76.23-1.08,0l-1.33-.97c-.32-.23-.46-.65-.33-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m75.42,19.03l2.24-1.63s0-.02,0-.03v-.15h-6.9v.15s0,.02,0,.03l2.24,1.63c.72.52,1.69.52,2.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m75.42,19.03l2.24-1.63s0-.02,0-.03v-.15h-6.9v.15s0,.02,0,.03l2.24,1.63c.72.52,1.69.52,2.41,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m26.21,36.54s24.08,21.53,35.02,27.13c0,0-6.73,12.62-1.66,24.62,0,0-5.82-8.67-1.77-23.83,0,0-26.58-20.9-31.58-27.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m55.44,65.5l-.5,2.41s-19.51-15.54-27-24.66c0,0,17.17,15.79,27.49,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m54.76,70.63l-.3,2.43s-17.83-14.44-24.9-23.06c0,0,15.45,14.55,25.2,20.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m54.31,76.07l.1,2.55s-16.94-13.84-23.32-21.84c0,0,14.4,13.64,23.22,19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m55.26,82.22l.9,3.3s-17.74-14.59-24.11-22.58c0,0,14.4,13.64,23.22,19.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m120.96,35.16s-23.13,22.55-33.82,28.61c0,0,7.26,12.32,2.72,24.53,0,0,5.45-8.91.75-23.89,0,0,25.66-22.02,30.35-29.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m93.01,65.35l.6,2.39s18.82-16.36,25.91-25.8c0,0-16.48,16.51-26.51,23.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m93.91,70.45l.41,2.41s17.19-15.2,23.88-24.11c0,0-14.81,15.2-24.29,21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m94.59,75.86v2.56s16.34-14.56,22.37-22.82c0,0-13.8,14.25-22.37,20.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.9,82.05l-.75,3.34s17.1-15.34,23.12-23.6c0,0-13.8,14.25-22.37,20.26Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerlessSteel);
export default __webpack_public_path__ + "static/media/peerless-steel.44e3f1ec43720f47cc6853f030e759f4.svg";
export { ForwardRef as ReactComponent };